<template>
  <div class="flex flex-col space-y-2">
    <div class="flex flex-col md:flex-row md:space-x-4 space-y-2 md:space-y-0">
      <div class="w-full">
        <el-select
          class="w-full"
          v-model="form.field"
        >
          <el-option
            v-for="(value , key ) in campos"
            :key="key"
            :label="campos[key].label"
            :value="campos[key].field"
          ></el-option>
        </el-select>
      </div>
      <div
        v-if="campos[form.field].type !== 'daterange'"
        class="w-full"
      >
        <el-select
          class="w-full "
          v-model="form.operator"
        >
          <el-option
            v-for="operator in operators"
            :key="operator.label"
            :label="operator.label"
            :value="operator.value"
          ></el-option>
        </el-select>
      </div>
      <div class="w-full">
        <field
          class="w-full"
          v-if="form.field"
          :key="form.field"
          :type="campos[form.field].type"
          :config="campos[form.field].config"
          v-model="form.value"
        ></field>
      </div>
      <div class="w-full md:w-6 self-center">
        <div class="hidden md:block">
          <i
            class="fa fa-plus cursor-pointer "
            @click="adicionarFiltro()"
          ></i>
        </div>
        <div class="md:hidden w-full ">
          <button
            @click="adicionarFiltro()"
            type="button"
            class="btn-primary w-full transition duration-300 ease-in-out focus:outline-none focus:shadow-outline
            bg-purple-500 hover:bg-purple-900 text-white font-normal py-2 px-4 mr-1 rounded"
          >Adicionar</button>
        </div>
      </div>
    </div>
    <div>
      <div
        v-for="(filter, index) in filters"
        :key="index"
        :class="styleList"
      >
        <div>
          {{filter.label}}
        </div>
        <div
          class="cursor-pointer text-red-600 font-weight-bold font-1xl"
          @click="filterDestroy(index)"
        >x</div>
      </div>
    </div>
  </div>
</template>

<script>
import Field from "./Field.vue";

export default {
  components: { Field },
  props: {
    campos: {
      type: Object
    },
    filterInitial: {
      type: Array,
      default: function () {
        return [];
      }
    },
    styleList: {
      type: String,
      default: function () {
        return 'flex space-x-3 justify-end';
      }
    }
  },
  data() {
    const operators = {
      'equal': {
        label: "igual",
        value: "equal"
      },
      'not_equal': {
        label: "diferente",
        value: "not_equal"
      },
      'like': {
        label: "contém",
        value: "like"
      },
      'greater_than': {
        label: "maior ou igual",
        value: "greater_than"
      },
      'less_than': {
        label: "menor ou igual",
        value: "less_than"
      }
    };
    const firstField = this.campos[Object.keys(this.campos)[0]];
    return {
      filters: [],
      form: {
        field: firstField.field,
        value: '',
        operator: 'equal'
      },
      operators
    }
  },
  methods: {
    adicionarFiltro() {
      let filter = { ... this.form };
      const fieldConfig = { ...this.campos[filter.field] };
      const { config: configField } = this.campos[filter.field];
      let labelValue = _.isPlainObject(this.form.value) ? this.form.value[configField.label] : this.form.value;
      if (fieldConfig.type == 'date') {
        labelValue = this.formatDate(labelValue);
      }
      if (fieldConfig.type == 'daterange') {
        labelValue = `entre ${this.formatDate(labelValue[0])} e ${this.formatDate(labelValue[1])}`;
      }

      if (fieldConfig.type == 'currency') {
        labelValue = this.formatValue(labelValue);
      }

      if (fieldConfig.type == 'daterange') {
        filter.label = `${this.campos[filter.field].label} ${labelValue}`;
      } else {
        filter.label = `${this.campos[filter.field].label} ${this.operators[filter.operator].label} ${labelValue}`;
      }

      filter.value = _.isPlainObject(this.form.value) ? this.form.value[configField.primarykey] : this.form.value;
      this.filters.push(filter);
      this.$emit('change', [...this.filters]);
    },
    filterDestroy(index) {
      let toDelete = [...this.filters];
      toDelete.splice(index, 1);
      this.filters = [...toDelete]
      this.$emit('change', [...this.filters])
    }
  },
  created() {
    this.filters = [...this.filterInitial];
  }
}

</script>

<style scoped>
</style>
